import { render, staticRenderFns } from "./AddLocalAudiance.vue?vue&type=template&id=0c936824&"
import script from "./AddLocalAudiance.vue?vue&type=script&lang=js&"
export * from "./AddLocalAudiance.vue?vue&type=script&lang=js&"
import style0 from "./AddLocalAudiance.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports